// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/css/main.scss
// module id = DG0N
// module chunks = 2